import context from '@truckdown/systems';
import accountComponents from '@truckdown/components-accounts';
import registerLocations from '@truckdown/locations';
import registerBilling from '@truckdown/billing';

import './Components';
import './Styles/main.less';
import './Images/vecteezy_man-having-a-conference-call-with-his-business-team-online_5514449.jpg';
import './Images/vecteezy_logistics-and-distribution-network-with-delivery-trucks-and_73777967.jpg';
import './Images/vecteezy_upload-file-with-cloud-storage-concept-illustration_10549844.jpg';
import './Images/promo.png';
import './Images/beyond_google_feature.png';

accountComponents.registerPrerequisites(context);
registerLocations(context);
registerBilling(context);

context.initialize().then(() => {
    console.log('System initialized');
});